import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { FileSpreadsheet, FileText, CheckSquare, Square } from 'lucide-react';

const FORMATOS = [
  { key: 'XLSX', label: 'Excel', icon: FileSpreadsheet },
  { key: 'PDF', label: 'PDF formal', desc: 'Constancia con membrete, número de pedido y firma', icon: FileText },
];

export const MotivoFormatos = ({ motivos, datos, setDatos, hojaResumen }) => {
  const set = (k, v) => setDatos((d) => ({ ...d, [k]: v }));
  const toggleFormato = (k) => set('formatos', datos.formatos.includes(k) ? datos.formatos.filter((x) => x !== k) : [...datos.formatos, k]);
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
      <div className="space-y-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <Label className="text-xs text-slate-500">Motivo (opcional)</Label>
            <Select value={datos.motivo || 'NINGUNO'} onValueChange={(v) => set('motivo', v === 'NINGUNO' ? null : v)}>
              <SelectTrigger className="mt-1" data-testid="expmov-motivo"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="NINGUNO">Sin motivo</SelectItem>
                {motivos.map((m) => <SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs text-slate-500">N° de oficio, expediente o caso</Label>
            <Input value={datos.referencia} maxLength={120} onChange={(e) => set('referencia', e.target.value)} placeholder="Opcional" className="mt-1" data-testid="expmov-referencia" />
          </div>
        </div>
        <div>
          <Label className="text-xs text-slate-500">Comentario</Label>
          <Textarea value={datos.comentario} maxLength={500} onChange={(e) => set('comentario', e.target.value)} rows={2} placeholder="Opcional" className="mt-1" data-testid="expmov-comentario" />
        </div>
      </div>
      <div>
        <Label className="text-xs text-slate-500">Formatos</Label>
        <div className="space-y-2 mt-1">
          {FORMATOS.map((f) => {
            const on = datos.formatos.includes(f.key);
            const Icon = f.icon;
            return (
              <button
                key={f.key}
                type="button"
                onClick={() => toggleFormato(f.key)}
                className={`w-full flex items-center gap-3 p-3 rounded-lg border bg-white text-left transition-colors ${on ? 'border-blue-600 ring-1 ring-blue-600' : 'border-slate-200 hover:border-slate-300'}`}
                data-testid={`expmov-formato-${f.key}`}
              >
                {on ? <CheckSquare className="h-4 w-4 text-blue-700" /> : <Square className="h-4 w-4 text-slate-400" />}
                <Icon className="h-5 w-5 text-slate-500" />
                <div>
                  <div className="text-sm font-medium text-slate-800 dark:text-slate-100">{f.label}</div>
                  <div className="text-xs text-slate-500">{f.key === 'XLSX' ? (hojaResumen ? 'Hoja Resumen y hoja con el detalle' : 'Hoja con el detalle de movimientos') : f.desc}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MotivoFormatos;
